<template>
  <div class="orders-scheduler-activities">
    <base-table
      :service="$options.maintenanceTaskService"
      fetch-func="generatedOrders"
      :fetch-params="{
        contract_id: contract || undefined,
        includes: 'scheduledLog,operations,operations.activityCode',
      }"
      :columns="columns"
      @fetch="(data) => $emit('fetch', data)"
      sticky
      class="activities-table"
      ref="baseTable"
    >
      <template #rowId="{ row }">
        <b-button
          type="is-text"
          class="generated-order-id"
          @click="() => viewOrder(row)"
        >
          {{ row.id }}
        </b-button>
      </template>
      <template #rowOperations="{ row }">
        {{ (row.operations || []).length }}
      </template>
    </base-table>
  </div>
</template>

<script>
import BaseTable from "@/components/partials/BaseTable";
import { MaintenanceTaskService } from "@/services/maintenanceTask.service";

export default {
  maintenanceTaskService: MaintenanceTaskService,
  components: {
    BaseTable,
  },
  props: {
    contract: {
      type: String,
    },
  },
  data: () => ({
    columns: [
      {
        field: "id",
        label: "Order",
        meta: {
          rowSlot: "rowId",
        },
      },
      {
        field: "operations",
        label: "Operations",
        meta: {
          rowSlot: "rowOperations",
        },
      },
      {
        field: "scheduled_log_id",
        label: "Scheduled Log ID",
      },
    ],
  }),
  watch: {
    contract() {
      this.$nextTick(() => {
        this.fetchOrders();
      });
    },
  },
  methods: {
    async fetchOrders() {
      await this.$refs.baseTable.fetchData();
    },
    viewOrder(order) {
      this.$router.push({ name: "order-list", query: { id: order.id } });
    },
  },
};
</script>

<style lang="scss">
.activities-table {
  .b-table, .table-wrapper {
    height: 70vh !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/OrdersScheduler/activities/index.vue